import React from "react";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined } from "us.icons";
import { $Popconfirm } from "us.common/components";
import { ExtendedFieldsActions } from "us.collection.admin/constants";

type ItemMenuProps = {
  actions?: ExtendedFieldsActions[];
  onCallAction: (actionType: ExtendedFieldsActions) => void;
};

/**
 * @description - Extended Fields table action menu.
 * @link Design Document - https://unicorn-solutions.atlassian.net/browse/UBX4-23848
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 18/03/2025
 */
const ItemMenu: React.FC<ItemMenuProps> = ({
  actions = [ExtendedFieldsActions.EDIT],
  onCallAction,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content" data-testid="popover-content">
      {actions.includes(ExtendedFieldsActions.EDIT) && (
        <div
          className="d-flex  flex-row more-item"
          data-testid="edit-btn"
          onClick={() => onCallAction(ExtendedFieldsActions.EDIT)}
        >
          <div className="p-1">
            <EditOutlined  />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.EDIT")}</div>
        </div>
      )}

      {actions.includes(ExtendedFieldsActions.DELETE) && (
        <$Popconfirm
          title={t("US.COLLECTION.COMMON:COMMON.SURE_TO_DELETE_?")}
          data-testid="popUpConfirm-box"
          onConfirm={() => onCallAction(ExtendedFieldsActions.DELETE)}
        >
          <div
            className="d-flex mb-2 flex-row more-item text-error"
            data-testid="delete-btn"
          >
            <div className="p-1">
              <DeleteOutlined  />
            </div>
            <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.DELETE")}</div>
          </div>
        </$Popconfirm>
      )}
    </div>
  );
};

export default ItemMenu;
